import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, Dropdown, Badge } from "antd";
import SignInModal from "../SignInModal";
import dropship_logo from "@/assets/dropship_logo.png";
import {
  MainContainer,
  InnerContainer,
  LogoWrapper,
  StyledLogo,
  MenuWrapperDesktop,
  ButtonsWrapper,
  LoginButton,
  SignupButton,
  MenuWrapperMobile,
  StyledBarsWrapper,
  SyledBarsmb,
  StyledClosemb,
  StyledLink,
  StyledDropdown,
  IconWrapper,
  StyledDivider,
  StyledMenuLink,
  StyledMenuContainer,
  ImageUserName,
  MenuImage,
  MenuText,
  MenuUserName,
  MenuEmail,
  MobileCartWrapper,
} from "./styles";
import ProductsDropdown from "./productsDropdown";
import cache from "utils/cache";
import UserIcon from "@/assets/icons/userIcon";
import CartIcon from "@/assets/icons/cartIcon";
import MyOrdersIcon from "@/assets/icons/myOrdersIcon";
import AddedProductIcon from "@/assets/icons/addedProductsIcon";
import SignOutIcon from "@/assets/icons/signOutIcon";
import { truncateWithEllipsis } from "utils/helpers";
import { useLogoutUserMutation } from "api/authApi";
import { useDispatch } from "react-redux";
import { performLogout } from "utils/logout";
import { useCartDrawer } from "context/CartDrawerContext";

const Header = () => {
  const user = cache.getItem("user");
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const [logoutUser] = useLogoutUserMutation();
  const { cartItems, openDrawer } = useCartDrawer();
  const [isOpen, setIsOpen] = useState(false);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [current, setCurrent] = useState("mail");
  const [signInModalOpen, setSignInModalOpen] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false); // New state for sign-up

  const maxLength = 14;
  const email = user?.email;
  const truncatedEmail = truncateWithEllipsis(email, maxLength);

  const handleCartClick = (event) => {
    event.preventDefault();
    openDrawer();
  };

  const getAuthMenuItem = () => {
    return user
      ? {
        label: "Sign Out",
        key: "logout",
      }
      : {
        label: "Sign In",
        key: "login",
      };
  };

  const MobileItems = [
    {
      label: "Product",
      key: "Product",
      children: [
        {
          label: "Best Selling Items",
          key: "/best-selling-products",
        },
        {
          label: "Third Party Items",
          key: "/third-party-products",
        },
        {
          label: "Private Sourcing",
          key: "privateSourcing",
        },
      ],
    },
    { type: "divider" },
    {
      label: "Resources",
      key: "resources",
      children: [
        {
          label: "About",
          key: "/about",
        },
        {
          label: "Terms of Service",
          key: "/terms_services",
        },
        {
          label: "Privacy Policy",
          key: "/privacy_policy",
        },
        {
          label: "Shipping Policy",
          key: "/shipping",
        },
        {
          label: "Return Policy",
          key: "/return_policy",
        },
      ],
    },
    { type: "divider" },
    {
      label: <StyledLink to="/pricing">Pricing</StyledLink>,
      key: "/pricing",
    },
    { type: "divider" },
    {
      label: "Settings",
      key: "/profile",
    },
    { type: "divider" },
    {
      label: "Orders",
      key: "/my-orders",
    },
    { type: "divider" },
    {
      label: "Added Products",
      key: "/product_list_Page",
    },
    { type: "divider" },
    {
      label: cartItems?.length
        ? `Cart (${cartItems.length})`
        : "Cart",
      key: "/cart",
    },
    { type: "divider" },
    getAuthMenuItem(),
  ];

  const toggleSignInModal = () => {
    setSignInModalOpen(!signInModalOpen);
  };

  const handleClick = (e) => {
    if (e.key === "login") {
      setIsSignUp(false); // Ensure it's set to sign in
      toggleSignInModal();
    } else if (e.key === "logout") {
      handleLogout();
    } else if (e.key === "/cart") {
      openDrawer();
    } else {
      setCurrent(e.key);
      navigate(e.key);
    }
  };
  const handleClickUser = (e) => {
    e.preventDefault(); // Prevent default link behavior
    const user = cache.getItem("user");
    if (user) {
      navigate("/supplier");
    } else {
      setIsSignUp(false); // Ensure it's set to sign in
      toggleSignInModal();
    }
  };

  const openMenu = () => {
    setIsOpen(true);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleLogout = async () => {
    await performLogout({
      dispatch,
      navigate,
      logoutMutation: logoutUser,
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSignUpClick = (isSignUp = false) => {
    setIsSignUp(isSignUp); // Set to sign up
    toggleSignInModal();
  };

  return (
    <MainContainer>
      <InnerContainer>
        <LogoWrapper>
          <StyledLogo
            onClick={() => navigate("/")}
            src={dropship_logo}
            alt="LOGO"
          />
        </LogoWrapper>
        <MenuWrapperDesktop>
          <StyledDropdown
            placement="bottom"
            open={isProductDropdownOpen}
            onOpenChange={setIsProductDropdownOpen}
            dropdownRender={() => <ProductsDropdown onClose={() => setIsProductDropdownOpen(false)} />}
          >
            <StyledLink>Product</StyledLink>
          </StyledDropdown>
          {/* <StyledLink>Resources</StyledLink> */}
          <StyledLink to="/pricing">Pricing</StyledLink>
          <StyledLink onClick={handleClickUser}>Become Supplier</StyledLink>
          <StyledDropdown
            placement="bottom"
            dropdownRender={() => (
              <Menu>
                <Menu.Item key="about">
                  <StyledLink to="/about">About</StyledLink>
                </Menu.Item>
                <Menu.Item key="terms">
                  <StyledLink to="/terms_services">Terms of Service</StyledLink>
                </Menu.Item>
                <Menu.Item key="privacy">
                  <StyledLink to="/privacy_policy">Privacy Policy</StyledLink>
                </Menu.Item>
                <Menu.Item key="shipping">
                  <StyledLink to="/shipping">Shipping Policy</StyledLink>
                </Menu.Item>
                <Menu.Item key="return">
                  <StyledLink to="/return_policy">Return Policy</StyledLink>
                </Menu.Item>
              </Menu>
            )}
          >
            <StyledLink>Resources</StyledLink>
          </StyledDropdown>
        </MenuWrapperDesktop>
        <MobileCartWrapper>
          <a href="/cart" aria-label="Cart" onClick={handleCartClick}>
            <Badge count={cartItems?.length} offset={[5, -5]}>
              <CartIcon />
            </Badge>
          </a>
        </MobileCartWrapper>
        <StyledBarsWrapper>
          <SyledBarsmb onClick={openMenu} aria-label="Open menu" />
        </StyledBarsWrapper>
        <MenuWrapperMobile isOpen={isOpen} ref={containerRef}>
          <StyledClosemb onClick={closeMenu} />
          <Menu
            onClick={handleClick}
            selectedKeys={[current]}
            mode="inline"
            items={MobileItems}
          />
        </MenuWrapperMobile>
        {/* <SearchWrapper>
          <Search
            placeholder="What are you looking for?"
            onSearch={onSearch}
            style={{
              width: 250,
            }}
          />
        </SearchWrapper> */}
        <ButtonsWrapper>
          {user ? (
            <>
              <IconWrapper>
                <Dropdown
                  dropdownRender={() => (
                    <div>
                      <StyledMenuContainer>
                        <ImageUserName>
                          <MenuImage src={dropship_logo} />
                          <div>
                            <MenuText>{`HI, `}</MenuText>
                            <MenuUserName>{user?.firstName}</MenuUserName>
                            <MenuEmail>{truncatedEmail}</MenuEmail>
                          </div>
                        </ImageUserName>
                        <div>
                          <IconWrapper>
                            <MyOrdersIcon />
                            <StyledMenuLink href="/my-orders">
                              {`My Orders`}
                            </StyledMenuLink>
                          </IconWrapper>
                        </div>
                        <StyledDivider />
                        {user?.role !== "DROPSHIPPER" && (
                          <>
                            <div>
                              <IconWrapper>
                                <AddedProductIcon />
                                <StyledMenuLink href="/product_list_Page">{`Added Products`}</StyledMenuLink>
                              </IconWrapper>
                            </div>
                            <StyledDivider />
                          </>
                        )}
                        <StyledDivider />
                        <div>
                          <IconWrapper>
                            <UserIcon color="#9CA3AF" />
                            <StyledMenuLink href="/profile">{`Profile`}</StyledMenuLink>
                          </IconWrapper>
                        </div>
                        <StyledDivider />
                        <div onClick={handleLogout}>
                          <IconWrapper>
                            <SignOutIcon />
                            <StyledMenuLink>{`Sign Out`}</StyledMenuLink>
                          </IconWrapper>
                        </div>
                      </StyledMenuContainer>
                    </div>
                  )}
                >
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <UserIcon color="#ED6928" />
                  </a>
                </Dropdown>
              </IconWrapper>
              <IconWrapper>
                <a href="/cart" onClick={handleCartClick}>
                  <Badge count={cartItems?.length} offset={[5, -5]}>
                    <CartIcon />
                  </Badge>
                </a>
              </IconWrapper>
            </>
          ) : (
            <>
              <LoginButton onClick={() => handleSignUpClick(false)}>
                Login
              </LoginButton>
              <SignupButton onClick={() => handleSignUpClick(true)}>
                Sign up for Free
              </SignupButton>
            </>
          )}
        </ButtonsWrapper>
      </InnerContainer>
      {signInModalOpen && (
        <SignInModal
          isModalOpen={signInModalOpen}
          toggleModal={toggleSignInModal}
          isSignUpMode={isSignUp}
          onSwitchMode={() => setIsSignUp((prev) => !prev)}
        />
      )}
    </MainContainer>
  );
};

export default Header;
